(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('ValuationApiCalls', ValuationApiCalls);

    ValuationApiCalls.$inject = ['$resource'];

    function ValuationApiCalls ($resource) {
        return $resource('api/reports/valuation-api-calls/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            // Body fetches (on demand, single row). The server returns the body already pretty-printed
            // (see ValuationApiCallLogResource#prettyOrRaw), so we pass the text through verbatim and the
            // dialog renders it in a <pre> — no client-side parsing (which would choke on Gnowise's NaN).
            'getResponseBody': {
                method: 'GET',
                url: 'api/reports/valuation-api-calls/:id/response',
                transformResponse: function (data) {
                    return { content: data };
                }
            },
            'getRequestBody': {
                method: 'GET',
                url: 'api/reports/valuation-api-calls/:id/request',
                transformResponse: function (data) {
                    return { content: data };
                }
            },
            // Raw upstream (Gnowise) response — internal.
            'getUpstreamResponseBody': {
                method: 'GET',
                url: 'api/reports/valuation-api-calls/:id/upstream-response',
                transformResponse: function (data) {
                    return { content: data };
                }
            },
            // The exact (transformed) payload we sent to Gnowise — internal.
            'getUpstreamRequestBody': {
                method: 'GET',
                url: 'api/reports/valuation-api-calls/:id/upstream-request',
                transformResponse: function (data) {
                    return { content: data };
                }
            },
            // CSV export honoring the current filters; bytes wrapped in a Blob for FileSaver.
            'export': {
                method: 'GET',
                url: 'api/reports/valuation-api-calls/export',
                responseType: 'arraybuffer',
                transformResponse: function (data) {
                    if (data) {
                        return { file: new Blob([data], { type: 'text/csv' }) };
                    }
                    return data;
                }
            }
        });
    }
})();
